import { Component, OnInit, Input } from '@angular/core';
import { Menu } from '../../../models/menu';
import { MenuService } from '../../../services/menu.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { PermisoService } from '../../../services/permiso.service';
import { SessionService } from '../../../services/session.service';
import { SweetMessage } from '../../../config/sweet-message';

@Component({
  selector: 'permiso-modal',
  templateUrl: './permiso-modal.component.html',
  styleUrls: ['./permiso-modal.component.css'],
  providers: [MenuService,PermisoService]
})
export class PermisoModalComponent implements OnInit {
    @Input() usuario_id: String;
    @Input() perfil_id: String;
    @Input() usuario: String;
    public loading: boolean;
    public menus: Array<Menu>;
    public permisos: Array<any>;
    public itemsSelected = [];
    
    public isEditable: boolean;
    public msg: SweetMessage;
    public selectAll: boolean;

	constructor(
        private menuService: MenuService,
        private permisoService: PermisoService,
        public bsModalRef: BsModalRef,
        private ss: SessionService,
    ) {
        this.loading = false;
        this.menus = [];
        this.permisos = [];
        this.isEditable = false;
        this.selectAll = false;
        this.msg = new SweetMessage();
	}

	ngOnInit() {
        this.loading = true;
		this.getMenus().then(
            res => {
                this.getPermisos().then(
                    res => this.loading = false,
                    err => this.loading = false
                );
            },
            err => this.loading = false
        );
    }

    onSelectAll(){
        this.itemsSelected = [];
        this.menus.map((m:any) => m.submenu.map (sb => {
            sb['isChecked'] = this.selectAll;        
            if( this.selectAll ){
                
                this.itemsSelected.push(sb['id']);
            }
            
        }));
    }
    
    onEdit() {
        this.loading = true;
        this.isEditable = !this.isEditable;
        this.getPermisos().then(
            res => this.loading = false,
            err => this.loading = false,
        );
    }

    getMenus() {
		return new Promise((resolve, reject) => {
			this.menuService.getAll('?usuario_id=' + this.ss.getData('usuario_id')).subscribe(
				res => {
					if (!res.length) {
						this.menus = [];
					} else {
						this.menus = res;
					}
					resolve();
				},
				err => {
					this.menus = [];
					reject(err);
				}
			);
		});
    }
    
    getPermisos(){
        return new Promise((resolve, reject) => {
            this.permisoService.getByUsuarioPerfil(this.usuario_id, this.perfil_id).subscribe(
                res => {
                    this.permisos = res;
                    this.itemsSelected = [];
                    this.menus.forEach((m:any) => m.submenu.forEach(sb => sb['isChecked']=false));
                    let isAllChecked = true;
                    this.menus.forEach((menu: any) => {
                        menu.submenu.forEach((submenu: any) => {
                            
                            this.permisos.forEach(obj => {
                                
                                if( submenu.id === obj.menu_id ){
                                    submenu['isChecked'] = true;
                                    this.itemsSelected.push(submenu.id);

                                    
                                    
                                }
                            
                               
                            });

                            if(!submenu['isChecked']) {
                                isAllChecked = false;    
                            }
                        });
                    });
                    if(isAllChecked) {
                        this.selectAll = true;
                    }else {
                        this.selectAll = false;
                    }
                    
                    resolve();
                },
                err => {
                    this.permisos = [];
                    reject(err);
                }
            );
        });
    }

    onSubmit(){
        let data = {
            'perfil_id': this.perfil_id,
            'usuario_permiso_id': this.usuario_id,
			'empresa_id': this.ss.getData('empresa_id'),
			'usuario_id': this.ss.getData('usuario_id'),
			'menus': this.itemsSelected
		};
		this.loading = true;
		this.permisoService.save(data).subscribe(
			res => {
				this.msg.showMessage('success-message', res.message);
				//this.itemsSelected = [];
                //this.permisos = [];
                this.isEditable = false;
                this.loading = false;
			},
			err => {
				this.loading = false;
				this.msg.showMessage('error-message',err);
			}
		);
    }
    
    findItemSelected(_id) {
		for (let i in this.itemsSelected) {
			if (_id == this.itemsSelected[i]) {
				return true;
			}
		}
		return false;
	}

	addItemSelected(event, _id) {
        // this.isEditable = true;
		if (event.target.checked) {
            this.itemsSelected.push(_id);
            
		} else {
			this.removeItemFromArr(this.itemsSelected, _id);
		}
	}

	removeItemFromArr(arr, _id) {
		let i;
		for (i in this.itemsSelected) {
			if (_id == this.itemsSelected[i]) {
				break;
			}
		}
		if (i !== -1) {
			arr.splice(i, 1);
		}
	}
}




// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/permiso-modal/permiso-modal.component.ts